module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#listicle",
      toString: function () {
        return this.url;
      }
    }